import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_DESIGNER,
  CREATE_LIBRARY_COMPONENT,
  CREATE_LIBRARY_FOLDER,
  DELETE_DESIGNER,
  DELETE_DESIGNER_VERSION,
  DELETE_LIBRARY_FOLDER,
  DESIGNER_GENERATE,
  GENERATE_CERTIFICATES,
  GENERATE_FACULTY_ID_CARDS,
  GENERATE_REPORT_CARDS,
  GENERATE_STUDENT_ID_CARDS,
  GET_DESIGNER_DETAIL,
  GET_DESIGNER_LIST,
  GET_DESIGNER_SPECIFIC_VERSION,
  GET_DESIGNER_VERSIONS,
  GET_LIBRARY_ITEM,
  GET_LIBRARY_TREE,
  IMPORT_LIBRARY_ASSET,
  PREVIEW_REPORT_CARD,
  RESTORE_DESIGNER_VERSION,
  UPDATE_DESIGNER,
  UPDATE_LIBRARY_ITEM,
} from 'setup/redux/Actions/Designer/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* designerSaga() {
  yield takeEvery(CREATE_DESIGNER, fetchData)
  yield takeEvery(GET_DESIGNER_LIST, fetchData)
  yield takeEvery(GET_DESIGNER_DETAIL, fetchData)
  yield takeEvery(GET_DESIGNER_VERSIONS, fetchData)
  yield takeEvery(GET_DESIGNER_SPECIFIC_VERSION, fetchData)
  yield takeEvery(UPDATE_DESIGNER, fetchData)
  yield takeEvery(DELETE_DESIGNER, fetchData)
  yield takeEvery(DELETE_DESIGNER_VERSION, fetchData)
  yield takeEvery(RESTORE_DESIGNER_VERSION, fetchData)
  yield takeEvery(GENERATE_STUDENT_ID_CARDS, fetchData)
  yield takeEvery(GENERATE_FACULTY_ID_CARDS, fetchData)
  yield takeEvery(CREATE_LIBRARY_FOLDER, fetchData)
  yield takeEvery(CREATE_LIBRARY_COMPONENT, fetchData)
  yield takeEvery(UPDATE_LIBRARY_ITEM, fetchData)
  yield takeEvery(GET_LIBRARY_ITEM, fetchData)
  yield takeEvery(DELETE_LIBRARY_FOLDER, fetchData)
  yield takeEvery(IMPORT_LIBRARY_ASSET, fetchData)
  yield takeEvery(GET_LIBRARY_TREE, fetchData)
  yield takeEvery(GENERATE_CERTIFICATES, fetchData)
  yield takeEvery(DESIGNER_GENERATE, fetchData)
  yield takeEvery(GENERATE_REPORT_CARDS, fetchData)
  yield takeEvery(PREVIEW_REPORT_CARD, fetchData)
}

export default designerSaga
